<template>
  <div id="app">
    <div v-if="'start' === state">
      <div id="splash" @click="start">
        <img src="./assets/splash.png">
        <button class="btn btn-lg btn-primary btn-block">Get Started</button>
      </div>
    </div>
    <div v-if="'quiz' === state">
      <quiz-item 
        v-for="(question, index) in questions"
        :question="question"
        :index="index"
        :selectedIndex="selectedIndex"
        :latest="latest"
        :length="length"
        :binding="question.binding"
        :key="index"
        @answer="answerQuestion"
        @prev="prevQuestion"
        @next="nextQuestion"></quiz-item>
    </div>
    <div v-if="'result' === state">
      <result
        :answers="answers"
        :loaded="loaded"
        @restart="restartQuiz"></result>
    </div>
  </div>
</template>

<script>
import Questions from '../static/questions.js'
import QuizItem from './components/QuizItem'
import Result from './components/Result'

export default {
  name: 'app',
  data() {
    return {
      state: "start",
      questions: Questions,
      selectedIndex: 0,
      latest: 0,
      length: Questions.length,
      loaded: 0,
      answers: [],
      logos: []
    }
  },
  methods: {
    answerQuestion(answer) {
      console.log('answer: ')
      console.dir(answer)
      // overwrite image if it already exists
      if (this.answers[answer.question.drawOrder]) {
        console.log('overwriting image')
        this.loaded--
      }

      // preload image based on question answer
      this.answers[answer.question.drawOrder] = {filename: answer.question.folder + '/' + answer.image + '.png'}
      this.preloadImage(answer.question.drawOrder)

      // update question binding (determines which question to use next if there is a list)
      if ("undefined" !== typeof answer.binding && (this.selectedIndex + 1) < this.length) {
        this.questions[this.selectedIndex + 1].binding = answer.binding
      }
      
      // update status variables
      this.selectedIndex++
      this.latest = Math.max(this.latest, this.selectedIndex)

      // toggle results if all questions are answered
      if ( this.selectedIndex >= this.length ) {
        this.state = "result"
      }
    },
    preloadImage(index) {
      var _self = this;
      _self.answers[index].image = new Image()
      _self.answers[index].loaded = false
      _self.answers[index].image.onload = function() {
        _self.answers[index].loaded = true
        _self.loaded++
        console.log('loaded: ' + _self.answers[index].filename)
      }

      _self.answers[index].image.src = './static/images/' + _self.answers[index].filename
    },
    prevQuestion() {
      console.log('previous question')
      if (0 < this.selectedIndex) {
        this.selectedIndex--
      }
    },
    nextQuestion() {
      console.log('next question')
      if (this.selectedIndex < this.length - 1) {
        this.selectedIndex++
      }
    },
    restartQuiz() {
      this.state = "quiz"
      this.selectedIndex = 0
      this.latest = 0
    },
    initializeAnswers() {
      console.log('initializing answers array')
      this.answers = []
      this.answers[3]  = {filename: "Shield Frame-01-01-01.png"}
      this.answers[9]  = {filename: "motto/1_Sash-01-01-01.png"}
      this.answers[11] = {filename: "share-logo.png"}//, logo: true, logoType: "standard"}
      //this.answers[12] = {filename: "share-logo.png", logo: true, logoType: "social"}
      this.preloadImage(3)
      this.preloadImage(9)
      this.preloadImage(11) 
      //this.preloadImage(12)
    },
    start() {
      this.state = "quiz"
    }
  },
  components: {
    QuizItem,
    Result
  },
  created() {
    // set default binding as 0 (by default the first question in a list of questions is chosen)
    this.questions = this.questions.map(function(obj) {
      obj.binding = 0
      return obj
    })
    this.initializeAnswers()
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat');
@import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');

#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #444;
  margin: 20px auto 0 auto;
  padding: 0 10px;
  max-width: 670px;
}

#splash {
  border-radius: 0.3rem;
  cursor: pointer;
}

#splash img {
  width: 100%;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}

#splash button {
  height: 70px;
  font-family: 'Montserrat', sans-serif;
  font-size: 2rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  background-color: #1e60ad;
  border-color: #0b4c88;
  cursor: pointer;
}

#splash:hover button {
  text-shadow: 0 3px 2px rgba(0,0,0,0.4);
  background-color: #0b4c88;
}
</style>



// WEBPACK FOOTER //
// App.vue?c4d69b2a